__turbopack_context__.v({
  "className": "noto_sans_kr_8cb95313-module__RJhFFa__className",
});
